import Modal from 'react-bootstrap/Modal';
import img from '../../assest/img12.png';
import modalStyles from '../../css/style.module.css';
import { getDownloadSummary } from './timesheetFilterUtils';
import successStyles from './TimesheetDownloadSuccessModal.module.css';

const TimesheetDownloadSuccessModal = ({ show, onHide, status, fromDate, toDate }) => {
  const { statusLabel, dateRangeLabel } = getDownloadSummary(status, fromDate, toDate);

  return (
    <Modal show={show} onHide={onHide} size="sl" centered>
      <Modal.Body style={{ padding: '30px' }}>
        <div className={modalStyles.modelsuccessfully}>
          <img src={img} alt="" />
          <p className={successStyles.title}>Successfully Downloaded</p>
          <p className={successStyles.subtitle}>
            Timesheet data for <strong>{statusLabel}</strong> status ({dateRangeLabel}) has been
            downloaded.
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TimesheetDownloadSuccessModal;
